import axios from 'axios-es6'

export const hookPartnersSite = response => {
  const flag = 'dontDisturbUserWithImsi'
  const isSimcardsListRegexp = /^\/api\/simcards(\?|$)/
  const isMTXSimcard = /^MTX/

  if (response.config.method !== 'get' || !isSimcardsListRegexp.exec(response.config.url)) return

  const notMTXSimcards = response.data.filter(simcard => !simcard.blocked)
    .filter(simcard => !isMTXSimcard.exec(simcard.partner))
  const notMTXPartners = notMTXSimcards.map(simcard => simcard.partner)
  const userFirstImsi = String(response.data?.[0]?.imsi)

  if (window.localStorage.getItem(flag) === userFirstImsi) return

  if (notMTXPartners.length === 0) return window.localStorage.setItem(flag, userFirstImsi)

  axios.get(`/api/get_partner_domain?part_id=${notMTXPartners.join(',')}`)
    .then(({ data: { domain_names } }) => {
      if (!Array.isArray(domain_names)) throw new Error('Result is not array')
      const partnerSite = domain_names[0]

      if (!partnerSite) return
      if (window.location.host === partnerSite) return

      document.querySelector('body > div').style.display = 'none'
      document.body.innerHTML = `
        <div id="preloader" class="preloader">
          <div class="preloader__icon">
            <div>
              <div class="preloader__text">connect</div>
            </div>
            <div></div>
          </div>
        </div>`
      window.location.href = `http://${partnerSite}`
    })
    .catch(err => {
      console.error("Can't get partner's domain part by part_id!", err)
    })
}



// WEBPACK FOOTER //
// ./app/javascript/utils/_partners_hook.js